import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Container, Row, Col, Card, CardHeader, Modal, Form, ModalBody, ModalFooter, ModalHeader, Label, Input, FormFeedback, ListGroup, ListGroupItem, Button } from '@/Components/ui';
;
//Import Breadcrumb
import BreadCrumb from "../../../Components/Common/BreadCrumb";
// import TableContainer from "../../../Components/Common/TableContainer";
import { Toaster } from 'react-hot-toast';
import Loader from "../../../Components/Common/Loader";
import { API_TICKETS, API_TICKET_ALL, changeTicket, deleteTicketItem, getDataFromUrl, refundTicketItem } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { read, utils, writeFileXLSX, writeFile } from "xlsx";
import QueryString from "qs";
import { dialogService } from "@/utils/dialogService";
import { buildServerListUrl } from "@/utils/serverListQuery";
const STATE_MODAL_FOCUS = {
    0: "사용처리",
    1: "사용취소",
};
const TicketList = () => {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");
    const [dataQuery, setDataQuery] = React.useState({});
    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
            setData(data.results);
            setPrevious(data.previous);
            setNext(data.next);
            setCount(data.count);
            // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
        })
            .catch((e) => {
            console.log(e);
        });
    };
    const refetch = () => {
        onRequestData(buildServerListUrl(API_TICKETS, dataQuery));
    };
    React.useEffect(() => {
        if (!previous && !next) {
            refetch();
        }
    }, []);
    const [checkedRecords, setCheckedRecords] = React.useState([]);
    const [stateChangeModal, setStateChangeModal] = React.useState(false);
    const [focusState, setFocusState] = React.useState(-1); // 0 : "사용처리", 1 : "사용취소"
    const [deleteModal, setDeleteModal] = useState(false);
    const togStateChangeModal = () => setStateChangeModal(!stateChangeModal);
    const togDeleteModal = () => setDeleteModal(!deleteModal);
    const columns = React.useMemo(() => [
        {
            Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()}/>,
            Cell: (cellProps) => {
                return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id}/>;
            },
            id: "#",
        },
        {
            Header: "번호",
            accessor: "row_number",
            id: "row_number",
        },
        {
            Header: "ID",
            accessor: "id",
            id: "id",
        },
        {
            Header: "고객",
            accessor: "고객",
            id: "order__user__username",
            Cell: (cellProps) => {
                return (<div>
              <div>{cellProps.row.original["이름"]}</div>
              <div>{cellProps.row.original["고객"]}</div>
            </div>);
            },
        },
        {
            Header: "상품",
            accessor: "상품",
            id: "order",
        },
        {
            Header: "만료일",
            accessor: "만료일",
            id: "expiration_date",
        },
        {
            Header: "상태",
            accessor: "상태",
            id: "state",
        },
        {
            Header: "사용일",
            accessor: "사용일",
            id: "used_date",
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["사용일"] !== "-" ? moment(cellProps.row.original["사용일"]).format("YYYY-MM-DD HH:mm") : ""}</span>;
            },
        },
        {
            Header: "선물",
            accessor: "gifted",
            id: "",
            Cell: (cellProps) => {
                return <span>{cellProps.row.original["gifted"] ? "선물됨" : null}</span>;
            },
        },
        {
            Header: "Actions",
            accessor: "Actions",
            id: "",
            Cell: (cellProps) => {
                return (<div className="d-flex gap-2">
              {cellProps.row.original["상태"] !== "사용함" && (<div className="edit">
                  <div className="text" style={{ cursor: "pointer", color: "#3577f1" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal();
                            setFocusState(0);
                        }}>
                    <i className="ri-pencil-fill fs-16"></i>
                  </div>
                </div>)}
              {cellProps.row.original["상태"] !== "사용안함" && (<div className="edit">
                  <div className="text" style={{ cursor: "pointer", color: "#ffbe0b" }} onClick={() => {
                            setCheckedRecords([cellProps.row.original]);
                            togStateChangeModal();
                            setFocusState(1);
                        }}>
                    <i className="ri-pencil-fill fs-16"></i>
                  </div>
                </div>)}
              <div className="remove">
                <div className="text-danger" style={{ cursor: "pointer" }} onClick={() => {
                        setCheckedRecords([cellProps.row.original]);
                        togDeleteModal();
                    }}>
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </div>
              </div>
            </div>);
            },
        },
    ], []);
    // const [modal, setModal] = useState(false);
    // const toggle = useCallback(() => {
    //   if (modal) {
    //     setModal(false);
    //     setCheckedRecords([]);
    //   } else {
    //     setModal(true);
    //   }
    // }, [modal]);
    const clearSelectedOptions = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        const checkall = document.getElementById("checkBoxAll");
        ele.forEach((element) => {
            element.checked = false;
        });
        checkall.checked = false;
        setFocusState(-1);
    };
    const deleteRecords = () => {
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await deleteTicketItem(record.id);
            }
            await dialogService.handleAlert("삭제 완료");
        })()
            .then(() => refetch())
            .catch((e) => console.log(e));
    };
    const refundRecords = async () => {
        if (await dialogService.confirm("환불처리를 진행하시겠습니까? CRM 환불은 고객 취소 정책과 관계없이 선택한 티켓만 관리자 강제 개별취소로 처리됩니다.") === false)
            return;
        (async () => {
            for (let i = 0; i < checkedRecords.length; i++) {
                const record = checkedRecords[i];
                await refundTicketItem(record.id);
            }
            await dialogService.handleAlert("환불 완료");
        })()
            .then(() => refetch())
            .catch(async (e) => {
                console.error(e);
                await dialogService.handleAlert(e, { force: "error" });
            });
    };
    const changeState = () => {
        (async () => {
            if (focusState === 0) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용안함") {
                        await changeTicket(record.id, "사용함");
                    }
                }
                await dialogService.handleAlert("사용처리 완료");
            }
            else if (focusState === 1) {
                for (let i = 0; i < checkedRecords.length; i++) {
                    const record = checkedRecords[i];
                    if (record["상태"] === "사용함") {
                        await changeTicket(record.id, "사용안함");
                    }
                }
                await dialogService.handleAlert("사용취소 완료");
            }
        })()
            .then(() => refetch())
            .catch((e) => console.log(e));
    };
    const changeCheckedRecords = () => {
        const ele = document.querySelectorAll(".customerCheckBox:checked");
        let checked = [];
        try {
            ele.forEach((element) => {
                let tmpArr = data.filter((item) => item.id.toString() === element.value.toString());
                let obj = tmpArr[0];
                checked.push(obj);
            });
        }
        catch (error) {
            console.log(error);
        }
        // console.log("changeCheckedRecords", checked)
        setCheckedRecords(checked);
    };
    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");
        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        }
        else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };
    return (<React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="사용자티켓" pageTitle="티켓"/>
          <Row>
            <Col lg={12}>
              <Card id="customerList">
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">사용자 티켓 목록</h5>
                      </div>
                    </div>
                    <div className="col-sm-auto">
                      <div className="hstack gap-2">
                        <Button onClick={async () => {
            await dialogService.handleAlert("액셀 파일을 다운로드합니다... 건수가 400건이 넘을 경우 파일에 누락될 수 있으니 유의하시기 바랍니다.");
            getDataFromUrl(`${API_TICKET_ALL}/?${QueryString.stringify(dataQuery)}`).then((data) => {
                const rows = data.map((row) => ({
                    // 	번호	ID	고객	상품	상태	사용일	만료일
                    번호: row.row_number,
                    id: row.id,
                    고객: row["고객"],
                    이름: row["이름"],
                    상품: row["상품"],
                    상태: row["상태"],
                    사용일: row["사용일"],
                    만료일: row["만료일"],
                }));
                const worksheet = utils.json_to_sheet(rows);
                const workbook = utils.book_new();
                utils.book_append_sheet(workbook, worksheet, "번호");
                writeFileXLSX(workbook, "output.xlsx");
            });
        }} color="soft">
                          <i className="ri-save-2-line"></i>
                        </Button>
                        <span style={{ padding: "4px" }}></span>

                        <Button onClick={() => {
            changeCheckedRecords();
            togStateChangeModal();
            setFocusState(0);
        }} color="soft-secondary" className="me-1">
                          사용처리
                        </Button>
                        <Button onClick={() => {
            changeCheckedRecords();
            togStateChangeModal();
            setFocusState(1);
        }} color="soft-warning" className="me-1">
                          사용취소
                        </Button>
                        <Button onClick={() => {
            changeCheckedRecords();
            togDeleteModal();
        }} color="soft-danger" className="me-1">
                          <i className="ri-delete-bin-2-line"></i>
                        </Button>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className="card-body pt-0 px-2">
                  <div>
                    <React.Fragment>
                      <ServerPaginatedTable url={API_TICKETS} columns={columns} data={data} previous={previous} next={next} count={count} onRequestData={onRequestData} onChangeQuery={setDataQuery} categories={[
            { id: 0, title: "전체", search: "", icon: "ri-store-2-fill" },
            { id: 1, title: "예약완료", search: "", icon: "ri-checkbox-circle-line" },
            { id: 2, title: "입금대기", search: "", icon: "ri-more-fill" },
            // { id: 3, title: "최소완료", search: "", icon: "ri-arrow-left-right-fill" },
        ]}/>
                    </React.Fragment>
                  </div>
                  <Toaster position="top-center"/>
                </div>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Modals */}

      {/* 티켓 상태 전환 Modal */}
      <Modal id="topmodal" isOpen={stateChangeModal} onClose={() => {
            clearSelectedOptions();
            togStateChangeModal();
        }}>
        <ModalHeader className="modal-title" id="myModalLabel" toggle={() => {
            clearSelectedOptions();
            togStateChangeModal();
        }}>
          {STATE_MODAL_FOCUS[focusState]}
        </ModalHeader>
        <ModalBody className="text-center p-5">
          <div className="mt-4">
            <h6 className="mb-3">{`선택하신 사용자의 티켓을 모두 ${STATE_MODAL_FOCUS[focusState]}하시겠습니까?`}</h6>
            <p className="text-muted mb-4">{focusState === 0 ? '"사용안함"인 티켓만 "사용함"으로 변경됩니다.' : '"사용함"인 티켓만 "사용안함"으로 변경됩니다.'}</p>
            {checkedRecords.length > 0 ? (<div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                <ListGroup>
                  {checkedRecords.map((record) => {
                return <ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["고객"]} - ${record["상품"]}`}</ListGroupItem>;
            })}
                </ListGroup>
              </div>) : (<span>{`${STATE_MODAL_FOCUS[focusState]}할 사용자 티켓을 먼저 선택해주세요.`}</span>)}
            <br />
            <br />
            <div className="hstack gap-2 justify-content-center">
              <button className={focusState === 0 ? "btn btn-soft-secondary fw-medium" : "btn btn-soft-warning fw-medium"} onClick={() => {
            clearSelectedOptions();
            togStateChangeModal();
        }}>
                <i className="ri-close-line me-1 align-middle"></i> Close
              </button>
              <button className={focusState === 0 ? "btn btn-secondary" : "btn btn-warning"} onClick={() => {
            changeState();
            setStateChangeModal(false);
        }} disabled={checkedRecords.length === 0}>
                {STATE_MODAL_FOCUS[focusState]}
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>

      {/* Delete Modal */}
      <Modal id="topmodal" isOpen={deleteModal} onClose={() => {
            clearSelectedOptions();
            togDeleteModal();
        }}>
        <ModalHeader className="modal-title" id="myModalLabel" toggle={() => {
            clearSelectedOptions();
            togDeleteModal();
        }}>
          삭제/환불
        </ModalHeader>
        <ModalBody className="text-center p-5">
          <div className="mt-4">
            <h5 className="mb-3">선택하신 사용자의 티켓을 모두 삭제하시겠습니까?</h5>
            {checkedRecords.length > 0 ? (<div className="live-preview" style={{ height: 200, overflowY: "scroll" }}>
                <ListGroup>
                  {checkedRecords.map((record) => {
                return <ListGroupItem key={record.id} style={{ whiteSpace: "pre-line" }}>{`${record.id} - ${record["고객"]} - ${record["상품"]}`}</ListGroupItem>;
            })}
                </ListGroup>
              </div>) : (<span>삭제를 원하시는 사용자 티켓을 먼저 선택해주세요.</span>)}
            <br />
            <br />
            <p>티켓내역 삭제(데이터만 삭제)하는 경우 PG사(토스)에서 직접 환불 처리해주셔야 합니다.</p>
            <div className="hstack gap-2 justify-content-center">
              <Button onClick={() => {
            clearSelectedOptions();
            togDeleteModal();
        }} className="bg-gradient-light fw-medium">
                <i className="ri-close-line me-1 align-middle"></i> 닫기
              </Button>
              <Button onClick={() => {
            deleteRecords();
            setDeleteModal(false);
        }} disabled={checkedRecords.length === 0} color="danger">
                티켓내역 삭제
              </Button>
              <Button onClick={() => {
            refundRecords();
            setDeleteModal(false);
        }} disabled={checkedRecords.length === 0} color="danger">
                환불처리
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>);
};
export default TicketList;
